export var validateFieldStateHandler = (fieldData, isExternalValid, state) => {
  var isFieldStateError = state === 'error';
  var isFieldLoading = (fieldData === null || fieldData === void 0 ? void 0 : fieldData.showLoader) === true;
  var isExternalValidityRequired = (fieldData === null || fieldData === void 0 ? void 0 : fieldData.isExternalValidityRequired) === true;
  var isValid = isExternalValid === true;
  if (isFieldStateError || isFieldLoading) {
    return false;
  }
  if (isExternalValidityRequired && !isValid) {
    return false;
  }
  return true;
};
export var validateFieldValueHandler = (fieldData, value, state) => {
  if (typeof (fieldData === null || fieldData === void 0 ? void 0 : fieldData.validationRegex) === 'string') {
    var validInput = value === null || value === void 0 ? void 0 : value.match(new RegExp(fieldData === null || fieldData === void 0 ? void 0 : fieldData.validationRegex));
    if (validInput && (validInput === null || validInput === void 0 ? void 0 : validInput.length) > 0 && state != 'error') {
      return true;
    }
    return false;
  }
  return true;
};